var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('cancel-heading',{attrs:{"is-centered":""}},[_vm._v("Subscription Paused")]),_vm._v(" "),_c('cancel-content',{attrs:{"is-centered":""}},[_vm._v("Your Forefront account access and billing has been paused temporarily.")]),_vm._v(" "),_c('cancel-icon')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }